import { render, staticRenderFns } from "./ListagemLogsHeader.vue?vue&type=template&id=f3fe85a8&scoped=true&"
import script from "./ListagemLogsHeader.vue?vue&type=script&lang=js&"
export * from "./ListagemLogsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListagemLogsHeader.vue?vue&type=style&index=0&id=f3fe85a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fe85a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VCol,VIcon,VRow,VTooltip})
